import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seoArticles';

export default function SEOArticles() {
  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
            <div>
              <p className="text-xs font-semibold text-secondary-600 uppercase tracking-widest mb-3">SEO Articles</p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
                AcBuy Spreadsheet <span className="italic text-primary-500">Guides &amp; Resources</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl leading-relaxed">
                Expert-written guides covering everything from safety and comparisons to category-specific shopping strategies.
              </p>
            </div>
            <Link
              to="/acbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              View All Articles
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {seoArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/${article.slug}`}
                className="group bg-background-100 hover:bg-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-48 md:h-52 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-background-50/85 backdrop-blur-sm text-xs font-semibold text-foreground-700">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                    <span>{article.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-2 mt-4 text-sm font-semibold text-primary-600">
                    <span>Read Article</span>
                    <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}